import React, { useState } from 'react';
import { useKitchenCart } from '../context/KitchenCartContext';
import { FaShoppingCart, FaCheck } from 'react-icons/fa';

const KitchenItem = ({ item, onItemAdded }) => {
  const { addToCart, cartItems } = useKitchenCart();
  const [isAdding, setIsAdding] = useState(false);
  
  // Check if item is already in cart
  const itemInCart = cartItems.find(cartItem => cartItem.uuid === item.uuid);
  const itemQuantity = itemInCart ? itemInCart.quantity : 0;
  
  // Format price (kitchen items use standard currency, not cents)
  const formatPrice = (price) => {
    return price.toLocaleString('en-US', {
      style: 'currency',
      currency: 'KES'
    });
  };

  const handleAddToCart = () => {
    setIsAdding(true);
    addToCart(item);
    
    // Show animation effect
    setTimeout(() => {
      setIsAdding(false);
      // Notify parent component to show cart modal
      if (onItemAdded) {
        onItemAdded();
      }
    }, 300);
  };

  // Get image URL or use default
  const imageUrl = item.image_url || '/assets/images/default.jpg';

  return (
    <div className="snack-item">
      <div className="snack-image">
        <img 
          src={imageUrl} 
          alt={item.name} 
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/assets/images/default.jpg';
          }} 
        />
        <div 
          className="category-badge" 
          style={{ backgroundColor: item.category_color || '#666' }}
        >
          {item.category_name}
        </div>
        {itemQuantity > 0 && (
          <div className="cart-badge">{itemQuantity}</div>
        )}
      </div>
      <div className="snack-details">
        <h3>{item.name}</h3>
        <p className="snack-description">{item.description}</p>
        <p className="snack-price">{formatPrice(item.price)}</p>
      </div>
      <button 
        className={`add-to-cart-btn ${isAdding ? 'adding' : ''} ${itemInCart ? 'in-cart' : ''}`}
        onClick={handleAddToCart}
        aria-label="Add to cart"
        disabled={item.status !== 'available' || item.quantity <= 0}
      >
        {itemInCart ? (
          <>
            <FaCheck className="icon-left" /> 
            <span>Add More</span>
          </>
        ) : (
          <>
            <FaShoppingCart className="icon-left" />
            <span>Add to Cart</span>
          </>
        )}
      </button>
    </div>
  );
};

export default KitchenItem;
